import { defineMessages } from 'react-intl';

export default defineMessages({
    paperlessPreference: {
        id: 'tdic.paperless.preference.Paperless Preference',
        defaultMessage: 'Paperless Preference'
    },
    cancel: {
        id: 'tdic.paperless.preference.Cancel',
        defaultMessage: 'Cancel'
    },
    submit: {
        id: 'tdic.paperless.preference.Submit',
        defaultMessage: 'Submit'
    },
    ok: {
        id: 'tdic.paperless.preference.Ok',
        defaultMessage: 'Ok'
    },
    paperlessReviewMsgWithEmail: {
        id: 'tdic.paperless.preference.Paperless review message',
        defaultMessage: 'Please review and update the paperless preference below. Paperless preference relates to your document delivery method for this policy only. Eligible documents will be provided electronically only and you will receive an email at [{pniEmail}] when new documents are available online.'
    },
    paperlessReviewMsgWithOutEmail: {
        id: 'tdic.paperless.preference.Paperless review message with out email',
        defaultMessage: 'Email address needed in order to go paperless. Please go to policy [{policyNumber}], click Edit Policy Profile and complete a Profile Change to submit the email address for policy and billing notifications.'
    },
    failureMessage: {
        id: 'tdic.paperless.component.failure',
        defaultMessage: 'Sorry, we were not able to setup paperless on your policy'
    },
    changeSubmitted: {
        id: 'tdic.paperless.component.Change Submitted',
        defaultMessage: 'Change Submitted'
    },
    submittedSuccessfully: {
        id: 'tdic.paperless.component.Your change request has been submitted successfully.',
        defaultMessage: 'Your change request has been submitted successfully.'
    },
    contactMsg: {
        id: 'tdic.paperless.component.A representative will contact you if any additional information is needed',
        defaultMessage: 'A representative will contact you if any additional information is needed.'
    },
    paperlessPreferredTooltip: {
        id: 'tdic.paperless.component.Select YES for paperless preferred to receive an email notification so that you can view your documents anytime at your convenience.',
        defaultMessage: 'Select YES for paperless preferred to receive an email notification so that you can view your documents anytime at your convenience.'
    },
});
